import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { adblockGraph } from 'lib/api/time';
import { paramConverter } from 'modules/common';
import PercentBarChart from 'components/organisms/Chart/PercentBarChart';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  barGraphBox: {
    width: '100%',
    minHeight: 150,
    border: 'solid 1px #e8e9ec',
    padding: '13px 12px',
    boxSizing: 'border-box',
    marginBottom: '20px',
  },
}));

const AdblockGraph = (props) => {
  const { params } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const graphKeyArray = {
    '01': [
      {
        code: 'device',
        title: t('Device별 점유율'),
        color: ['#EB483A', '#343434'],
      },
      {
        code: 'browser',
        title: t('Browser별 점유율'),
        color: [
          '#0c87DA',
          '#EB483A',
          '#19CE60',
          '#A6A6A6',
          '#343434',
          '#0FADE8',
          '#E28E22',
          '#FFDC00',
          '#4867AA',
        ],
      },
      {
        code: 'os',
        title: t('OS별 점유율'),
        color: [
          '#343434',
          '#0c87DA',
          '#4867AA',
          '#A6A6A6',
          '#FFDC00',
          '#EB483A',
          '#0FADE8',
        ],
      },
    ],
    '02': [
      {
        code: '01',
        title: 'PC',
        color: ['#343434', '#A6A6A6'],
      },
      {
        code: '02',
        title: 'MOBILE',
        color: ['#EB483A', '#A6A6A6'],
      },
    ],
    '03': [
      {
        code: '01',
        title: 'Chrome',
        color: ['#EB483A', '#A6A6A6'],
      },
      {
        code: '02',
        title: 'IE',
        color: ['#0c87DA', '#A6A6A6'],
      },
      {
        code: '03',
        title: 'Safari',
        color: ['#0FADE8', '#A6A6A6'],
      },
      {
        code: '04',
        title: 'Samsung',
        color: ['#343434', '#A6A6A6'],
      },
      {
        code: '05',
        title: 'Naver',
        color: ['#19CE60', '#A6A6A6'],
      },
      {
        code: '06',
        title: 'Facebook',
        color: ['#4867AA', '#A6A6A6'],
      },
      {
        code: '07',
        title: 'Daumkakao',
        color: ['#FFDC00', '#A6A6A6'],
      },
      {
        code: '08',
        title: 'Firefox',
        color: ['#E28E22', '#A6A6A6'],
      },
      {
        code: '99',
        title: 'etc',
        color: ['#343434', '#A6A6A6'],
      },
    ],
    '04': [
      {
        code: '01',
        title: 'Android',
        color: ['#343434', '#A6A6A6'],
      },
      {
        code: '02',
        title: 'iOS',
        color: ['#0FADE8', '#A6A6A6'],
      },
      {
        code: '03',
        title: 'Windows',
        color: ['#0c87DA', '#A6A6A6'],
      },
      {
        code: '04',
        title: 'MacOS',
        color: ['#4867AA', '#A6A6A6'],
      },
      {
        code: '05',
        title: 'Linux',
        color: ['#FFDC00', '#A6A6A6'],
      },
      {
        code: '06',
        title: 'ChromeOS',
        color: ['#EB483A', '#A6A6A6'],
      },
      {
        code: '99',
        title: 'etc',
        color: ['#343434', '#A6A6A6'],
      },
    ],
  };

  const [graphList, setGraphList] = useState([]);
  const [graphLoading, setGraphLoading] = useState(true);
  useEffect(() => {
    setGraphLoading(true);
    adblockGraph({ ...paramConverter(params), group: params.group })
      .then((response) => {
        const { data } = response.data;
        let newGraphList = [];
        graphKeyArray[params.group].forEach((row) => {
          newGraphList.push({
            color: row.color,
            key: row.code,
            title: row.title,
            data: data.bar[row.code].INFW_CNT.data,
            label: data.bar[row.code].INFW_CNT.data,
            total: parseInt(data.bar[row.code].INFW_CNT.total),
          });
        });

        newGraphList.sort(function (a, b) {
          return b.total - a.total;
        });
        setGraphList(newGraphList);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setGraphLoading(false);
      }); // eslint-disable-next-line
  }, [params]);

  /**
   * bar그래프 생성함수
   * @returns {Array}
   */
  const makeBarchartList = useCallback(
    (graphList) => {
      const result = [];
      if (graphList !== null && graphList.length !== 0) {
        graphList.forEach((grapData) => {
          result.push(
            <>
              <div className={classes.barGraphBox} key={grapData.code}>
                <PercentBarChart
                  key={grapData.code}
                  name={grapData.code}
                  loading={graphLoading}
                  data={grapData}
                  title={grapData.title}
                  color={grapData.color}
                  barSize={50}
                />
              </div>
            </>
          );
        });
      }
      return result;
    },
    [graphLoading, classes]
  );

  return <>{makeBarchartList(graphList)}</>;
};

const equalComparison = (prevProps, nextProps) => {
  if (JSON.stringify(prevProps.params) !== JSON.stringify(nextProps.params)) {
    return false;
  }
};

AdblockGraph.propTypes = {
  params: PropTypes.object.isRequired,
};
export default React.memo(AdblockGraph, equalComparison);
